export default {
  namespaced      : true,
  state           : {
    isModalOpen   : false,
    character     : null,
    podRoom       : null,

    isCharacterConfirmModalOpen         : false,
    characterConfirmModalSubmitLoading  : false
  },

  mutations   : {
    setIsOpenModal(state, value){
      state.isModalOpen = value;
    },

    setCharacter(state, value){
      state.character = value;
    },

    setPodRoom(state, value){
      state.podRoom = value;
    },

    setIsCharacterConfirmModalOpen(state, value){
      state.isCharacterConfirmModalOpen = value;
    },

    setCharacterConfirmModalSubmitLoading(state, value){
      state.characterConfirmModalSubmitLoading = value;
    },

    resetStore(state){
      state.isModalOpen = false;
      state.character   = null;
      state.podRoom     = null;

      state.isCharacterConfirmModalOpen         = false;
      state.characterConfirmModalSubmitLoading  = false;
    }
  },

  actions : {
    updateConnectionManageModal(context, payload){
      if(typeof payload.value !== 'undefined'){
        context.commit('setIsOpenModal', payload.value);
      }

      if(typeof payload.character !== 'undefined'){
        context.commit('setCharacter', payload.character);
      }
    },

    updateCharacterConfirmModal(context, payload){
      if(typeof payload.value !== 'undefined'){
        context.commit('setIsCharacterConfirmModalOpen', payload.value);
      }

      if(typeof payload.podRoom !== 'undefined'){
        context.commit('setPodRoom', payload.podRoom);
      }

      if(typeof payload.isSubmitLoading !== 'undefined'){
        context.commit('setCharacterConfirmModalSubmitLoading', payload.isSubmitLoading);
      }
    },

    resetStore(context){
      context.commit('resetStore');
    }
  }
}